<template>
    <div class="bg-white shadow-custom px-4 py-4.5 my-4 rounded-sm" data-cy="container_history_point_item_main">
        <div class="flex justify-between">
            <div class="w-3/5 text-14" data-cy="container_history_point_item_message">
                <div class="font-bold text-a-blue-2140a6" data-cy="text_history_point_item_message_campaign">
                    {{title}}
                </div>
                <div class="text-a-gray-999999 pt-2" data-cy="container_history_point_item_footer">
                    <span data-cy="text_history_point_item_date">{{isEarnPoint ? lbl.history.date_get_point : lbl.history.date_use_point}}</span>
                    {{FilterDateTimeShortMonthFormat(pointItem.timestamp)}}
                </div>
            </div>
            <div class="w-2/5 font-bold text-14 text-right"
                data-cy="container_history_point_item_points"
                :class="[!isEarnPoint ? 'text-a-red-ff4d4d' : 'text-a-green-3dcc6d']">
                <span v-if="isEarnPoint" data-cy="text_history_point_item_points_plus">+</span><span :data-cy="`text_history_point_item_points_${isEarnPoint ? 'earn' : 'burn'}`">{{getPointMessage()}}</span>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'HistoryPointItem',
    mixins: [LocaleMixin],
    props: {
        pointItem: { type: Object, required: true },
    },
    data: function(){
        return {
            title: '',
        }
    },
    computed: {
        isEarnPoint: function() {
            return this.pointItem.points >= 0;
        },
    },
    created: function(){
        //console.log('pointItem', this.pointItem);
        this.getTitle();
    },
    methods: {
        getTitle: function(){
            if(this.pointItem == null) return;

            if(this.pointItem.type == 'redeem'){
                this.title = this.pointItem.campaignName;
            }else{
                this.title = this.lbl.history.title_earn;
            }
        },
        getPointMessage: function () {
            // var pointUnit = this.lbl.history.point + (this.pointItem.points > 1 && this.localeCode == 1033 ? 's' : '');
            return this.FilterNumberFormat(this.pointItem.points) + " " + this.lbl.history.point;
        },

    }
}
</script>
<style lang="scss" scoped>
</style>
